import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import HiddenField from "../../Form/HiddenField";
import TextField from "../../Form/TextField";
import SearchField from "../../Form/SearchField";
import { OpportunitySourceCategorySearch } from "../OpportunitySourceCategory/OpportunitySourceCategorySearch";
export const getOpportunitySourceSaveRequest = (formState) => {
    return {
        id: formState.id,
        name: formState.name,
        description: formState.description,
        opportunitySourceCategoryId: formState.opportunitySourceCategory.id,
    };
};
const OpportunitySourceForm = () => {
    return (_jsxs(_Fragment, { children: [_jsx(HiddenField, { name: "id" }), _jsx(TextField, { name: "name", label: "Name", required: true }), _jsx(TextField, { name: "description", label: "Description" }), _jsx(SearchField, { label: "Category", name: "opportunitySourceCategory", as: (provided) => _jsx(OpportunitySourceCategorySearch, Object.assign({}, provided)), required: true })] }));
};
export default OpportunitySourceForm;
